import { t } from "@/i18n-js/instance";
import {
  isDigitalWallet,
  isLink,
  isSepaDebit,
} from "@/react/helpers/paywallCheckoutHelpers";
import { classNames } from "@/react/helpers/twMergeWithCN";
import type {
  CardBrand,
  PaymentMethodType,
} from "@/react/types/Paywalls/PaymentMethodTypes";
import { CardBrandIcon } from "./CardBrandIcon";
import { TypeIcon } from "./TypeIcon";
import { copyComponentMap, localeRoot } from "./constants";
import type { Variant } from "./types";

export interface LineProps {
  cardBrand?: CardBrand;
  className?: string;
  type: PaymentMethodType;
  value?: string;
  valueWeight?: "normal" | "medium";
  variant: Variant;
}

export const Line = ({
  className,
  variant,
  type,
  cardBrand,
  valueWeight = "normal",
  value,
}: LineProps) => {
  const CopyComponent = copyComponentMap[variant];

  let copy: string = t([localeRoot, type]);
  let icons: React.ReactNode = <TypeIcon variant={variant} type={type} />;

  if (cardBrand) {
    if (isDigitalWallet(type) || isLink(type)) {
      icons = (
        <div className="flex flex-row items-center gap-x-1">
          <TypeIcon variant={variant} type={type} />
          <CardBrandIcon variant={variant} cardBrand={cardBrand} />
        </div>
      );
    } else {
      icons = <CardBrandIcon variant={variant} cardBrand={cardBrand} />;
    }

    if (value) {
      copy = t([localeRoot, "value", "last4"], { value });
    }
  } else if (isLink(type) && value) {
    copy = t([localeRoot, "value", "identifier"], { value });
  } else if (isSepaDebit(type) && value) {
    copy = t([localeRoot, "value", "last4"], { value });
  }

  return (
    <div
      className={classNames(className, "flex flex-row items-center gap-x-2")}
    >
      {icons}
      <CopyComponent weight={valueWeight}>{copy}</CopyComponent>
    </div>
  );
};
